import { DOCUMENT_STEPS_COPY } from '@/flow/copy/documentSteps';
import { SUPPORT_COPY } from '@/flow/copy/support';
import { FLOW_COPY } from './flow';

/**
 * The English deck — the SOURCE OF RECORD. Aggregates the three copy decks
 * (document steps + support + the extracted flow). Every other locale's deck
 * mirrors this key set exactly; `isDeckComplete` refuses to offer a locale
 * that covers less.
 */
export const EN_DECK = {
  ...DOCUMENT_STEPS_COPY,
  ...SUPPORT_COPY,
  ...FLOW_COPY,
} as const;

export type DeckKey = keyof typeof EN_DECK;
